// Persistence for the ONE auto-starting tour (the dashboard / first-website-visit walkthrough).
// Per-page "Tour this page" walkthroughs are button-only and never auto-start, so they need no
// persisted state. Bump the suffix to re-introduce the dashboard tour to existing users.
const SEEN_KEY = 'bls_dashboardTourSeen_v1';

/** True once the dashboard tour has auto-shown (or been shown) — it then never auto-starts again. */
export function hasSeenDashboardTour(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

/** Mark the dashboard tour seen so it never auto-starts again (the button still replays it). */
export function markDashboardTourSeen(): void {
  try {
    localStorage.setItem(SEEN_KEY, '1');
  } catch {
    /* private mode / storage disabled — worst case it may auto-show again */
  }
}
